<div class="dropdown-navigation">
  <button class="dropdown-navigation__arrow" (click)="navigateToPrevious()">
    <q-arrow class="white smaller"></q-arrow>
  </button>
  <select
    class="dropdown-navigation__selector form-control"
    (change)="navigateTo($event.target.value)"
  >
    <option
      *ngFor="let item of items"
      [value]="item.id"
      [selected]="item.id === currentItemId"
    >
      {{ item.name }}
    </option>
  </select>
  <button class="dropdown-navigation__arrow" (click)="navigateToNext()">
    <q-arrow class="white smaller right"></q-arrow>
  </button>
</div>
